import { getDeviceId, getDeviceSourceHeaders } from '@/api/request';

export const officeAuthHeaders = (language?: string): Record<string, string> => ({
  'X-App-Id': '2',
  'X-Acc-Lang': language || localStorage.getItem('arco-lang') || 'en-US',
  'X-Device-Id': getDeviceId(),
  ...getDeviceSourceHeaders(),
});
